<template>
  <v-container fluid class="alert-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-alert`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Alert
          </v-tab>
          <v-tab
            v-show="initvalue.alerttype=='Alert'"
            class="mr-5"
            :href="`#tab-items`"
          >
            <v-icon class="mr-3">mdi-playitem-check</v-icon>
            Items
          </v-tab>
          <v-tab-item
            :value="'tab-alert'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row no-gutters>
                  <v-col class="ml-4" cols="12" md="9"><p class="text-h5">Edit Alert</p></v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" md="3">
                    <v-text-field
                      class="mb-2 ml-4 mr-4"
                      outlined
                      dense
                      v-on:change="updateChangedValue($event, 'alertcode')"
                      v-bind:value="edit_alert.alertcode"
                      placeholder="Alert Code"
                      persistent-hint
                      single-line hint="Enter the alert code">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      class="mb-2 ml-4 mr-4"
                      outlined
                      dense
                      v-on:change="updateChangedValue($event, 'alertname')"
                      v-bind:value="edit_alert.alertname"
                      placeholder="Alert Name"
                      persistent-hint
                      single-line hint="Enter the alert name">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select
                      class="mb-2 ml-4 mr-4"
                      :items=alerttype
                      outlined
                      dense
                      :value="edit_alert.alerttype"
                      v-on:change="updateChangedValue($event, 'alerttype')"
                      placeholder="Type"
                      persistent-hint
                      single-line hint="Please choose the alert type">
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-text-field
                      class="mb-2 ml-4 mr-4"
                      dense
                      v-on:change="updateChangedValue($event, 'notify_email')"
                      v-bind:value="edit_alert.notify_email"
                      placeholder="Alert Email"
                      persistent-hint
                      single-line hint="Enter the notify email">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      class="mb-2 ml-4 mr-4"
                      dense
                      v-on:change="updateChangedValue($event, 'notify_email2')"
                      v-bind:value="edit_alert.notify_email2"
                      placeholder="Alert Email Bcc"
                      persistent-hint
                      single-line hint="Enter the notify email bcc">
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col class="ml-4 mt-4" cols="12" md="9">
                    <v-form>
                      <label>
                        <h6>Alert Subject</h6> 
                      </label>
                      <v-text-field
                        class="mb-4"
                        :value="edit_alert.alertsubject"
                        v-on:change="updateChangedValue($event, 'alertsubject')"
                        dense
                        placeholder="Subject"
                      >
                      </v-text-field>
                      <label>
                        <h6>Alert Sms</h6> 
                      </label>
                      <v-text-field
                        class="mb-4"
                        :value="edit_alert.alertsms"
                        v-on:change="updateChangedValue($event, 'alertsms')"
                        dense
                        placeholder="Sms"
                      >
                      </v-text-field>
                      <label>
                        <h6>Alert Email</h6> 
                      </label>
                      <vue-editor 
                        v-model="edit_alert.alertemail"
                        @text-change="updateChangedValue(edit_alert.alertemail, 'alertemail')"
                        :value="edit_alert.alertemail"
                      >
                      </vue-editor>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col class="ml-5 mr-5" cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/alert/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="editAlert()">
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Alert Items</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="isAddItem = true"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="itemHeaders"
                        :items="alertitems"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="deleteItemDialog" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ deleteitem.itemname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="deleteItemDialog = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteAlertItem(deleteitem)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>                    
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editAlertItemSheet(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteAlertItemDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/alert/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="isAddItem"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Item</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="item.itemname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="item.itememail"
                  label="Email"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="item.itemmobile"
                  label="Mobile"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddItem = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addAlertItem"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <v-row>
      <v-bottom-sheet scrollable v-model="showItemSheet" inset>
        <v-sheet class="text-center" height="250px" style="overflow-x: hidden;">
          <v-btn class="mt-6" text color="error" @click="showItemSheet = !showItemSheet">
            close
          </v-btn>
          
          <v-row justify="center">
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="updateChangedItem($event, 'itemname')"
                  v-model="edititem.itemname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="updateChangedItem($event, 'itememail')"
                  v-model="edititem.itememail"
                  label="Email"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-on:change="updateChangedItem($event, 'itemmobile')"
                  v-model="edititem.itemmobile"
                  label="Mobile"
                  required
                ></v-text-field>
              </v-col>
          </v-row>
          <v-row justify="center">
              <v-col cols="12" md="11">
                 <v-btn
            class="button-shadow"
            color="warning"
            @click="editAlertItem()"
          >
            Edit
          </v-btn>
              </v-col>
          </v-row>
         
        </v-sheet>
      </v-bottom-sheet>
      <v-bottom-sheet scrollable v-model="showImageSheet" inset>
        <v-sheet class="text-center" height="350px" style="overflow-x: hidden;">
          <v-btn class="mt-6" text color="error" @click="showImageSheet = !showImageSheet">
            close
          </v-btn>
          <v-row justify="center">
              <v-col cols="12" md="1">
                <v-text-field
                  v-on:change="updateChangedImage($event, 'imagerank')"
                  :value="editimage.imagerank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="9">
                <v-text-field
                  v-on:change="updateChangedImage($event, 'imagename')"
                  :value="editimage.imagename"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" md="9">
              <v-file-input outlined dense label="File input" v-model="imagefile" v-on:change="onImageFileChange" accept="image/*" />     
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                outlined
                dense
                v-on:change="updateChangedImage($event, 'imageinfo')"
                :value="editimage.imageinfo"
                label="Info"
                required
              ></v-text-field>
            </v-col>
          </v-row>
           <v-row justify="center">
              <v-col cols="12" md="11">
                 <v-btn
            class="button-shadow"
            color="warning"
            @click="editAlertImage()"
          >
            Edit
          </v-btn>
              </v-col>
           </v-row>
         
        </v-sheet>
      </v-bottom-sheet>
  </v-row>
  </v-container>
</template>

<script>
import {VueEditor} from "vue2-editor";
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  components: {
    VueEditor
  },
  data () {
    return {
      imageHeaders: [
        { text: "#", value: "imagerank", width: "10px" },
        { text: "Image", value: "imageurl", width: "10%"},
        { text: "Name", value: "imagename" , width: "65%"},
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      itemHeaders: [
        { text: "Name", value: "itemname" },
        { text: "Email", value: "itememail" },
        { text: "Mobile", value: "itemmobile" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      edit_alert: {},
      change_alert: {},
      alertitems: [],
      alertimages: [],
      initvalue: {},
      alerttype: ['Alert', 'Other Alert'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      item: {},
      edititem: {},
      deleteitem: {},
      deleteItemDialog: false,
      isAddItem: false,
      showItemSheet: false,
      image: {},
      imagefile: null,
      editimage: {},
      deleteimage: {},
      deleteImageDialog: false,
      showImageDialog: false,
      showImageSheet: false,
    }
  },
  computed: {
    ...mapState('Alert', ['isReceiving'])
  },
  methods: {
    ...mapActions('Alert', 
    ['getAlertsRequest','deleteAlertImageRequest', 'deleteAlertItemRequest',
      'insertAlertItemRequest', 'updateAlertRequest', 'updateAlertItemRequest',
    ]),
    async addAlertItem() {
      this.isAddItem = false;
      this.item.alertid = this.initvalue._id;
      let result = await this.insertAlertItemRequest(this.item);
      this.alertitems.push(result);
      this.item = {};
    },
    deleteAlertItemDialog(item) {
      this.deleteItemDialog = true;
      this.deleteitem = {
        _id: item._id,
        itemname: item.itemname,
      };
    },
    async deleteAlertItem(payload) {
      this.deleteItemDialog = false;
      let response = await this.deleteAlertItemRequest(payload);
      let index = this.alertitems.findIndex((trans) => trans._id == response._id);
      this.alertitems.splice(index, 1);
    },
    async editAlert() {
      this.change_alert._id = this.initvalue._id;
      await this.updateAlertRequest(this.change_alert);
      this.getAlertsRequest();
      router.push('/alert/list');
    },
    async editAlertItem() {
      this.showItemSheet = false;
      this.item.alertitemid = this.edititem._id;
      let response = await this.updateAlertItemRequest(this.item);
      let index = this.alertitems.findIndex((x) => x._id == response._id);
      this.alertitems.splice(index, 1, response);
    },
    editAlertItemSheet(item) {
      this.item = {};
      this.showItemSheet = true;
      this.edititem = Object.assign({}, item);
    },
    onImageFileChange(file) {
      if (!file) {return;}
      this.item.imagefile = file;
      this.item.imagefilename = file.name;
      this.image.imagefile = file;
      this.image.imagefilename = file.name;
    },
    updateChangedValue(value, field){
      this.change_alert[field] = value;
    },
    updateChangedImage(value, field){
      this.image[field] = value;
    }, 
    updateChangedItem(value, field){
      this.item[field] = value;
    },    
  },

  created () {
    this.initvalue = this.$route.params;
    this.edit_alert = Object.assign({}, this.initvalue);
    this.alertitems = this.initvalue.items;
    if(!this.initvalue._id) this.$router.push({ name: 'AlertItem' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
